import { Typography, AppHeader, Link, Box, ButtonGroup, Button } from '@ace-clublabs/shared-component-library';
import React, { useContext, useLayoutEffect, useState } from 'react';
import { MembershipAppStateContext } from '../components/MembershipAppState/MembershipAppState';
import { FlowType } from '@ace-clublabs/common-membership-api-types';
import { getClubContent, ClubContentName } from '../utils/getClubContent';
import CookieHelper from '../utils/cookieHelper';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { useLocation } from 'react-router-dom';
import { Pages } from '@lib/types';

interface LocationState {
  referer?: string;
  flow?: FlowType;
}

export const SorryPage: React.FC = () => {
  const { sessionData, sendTag } = useContext(MembershipAppStateContext);
  const locationState = useLocation<LocationState>()?.state;
  const locationReferer = locationState?.referer;
  const locationFlow = locationState?.flow;
  const isRejoinFlow = locationFlow?.toUpperCase() === FlowType.REJOIN;

  let offerToken, statusDescription: string | undefined | null, isGiftFlow: boolean, flowType;
  const navigatedFromStatelessConfirmationPage = locationReferer === Pages.StatelessConfirmationPage;

  if (!navigatedFromStatelessConfirmationPage) {
    offerToken = sessionData?.offerToken;
    statusDescription = sessionData?.statusDescription;
    flowType = sessionData?.flowType;
    isGiftFlow = flowType === FlowType.GIFT;
  }

  const phoneNumber = navigatedFromStatelessConfirmationPage
    ? '1-844-786-1615'
    : getClubContent(ClubContentName.ContactPhoneText, CookieHelper.getClubCodeFromZipcodeCookie());

  const [isTagging, setIsTagging] = useState(true);

  useLayoutEffect(() => {
    if (navigatedFromStatelessConfirmationPage) {
      const tags = {
        channel: 'membership',
        mem_benefitlevel: 'MBRSHP_BASIC',
        mem_promo_type: locationFlow?.toUpperCase() === FlowType.B2B_MAJOR_ROCKET ? 'major rocket' : '',
        page: `membership:${isRejoinFlow ? 'rejoin' : 'join'}:error page`,
        subchannel1: `${isRejoinFlow ? 'rejoin' : 'join'}`,
      };
      UtagHelper.dispatchTntSpaEvent(tags);
      UtagHelper.view(tags);
    } else {
      const flow = isGiftFlow ? 'gift' : 'join';
      const page = isGiftFlow ? 'membership:gift:error' : 'error page';
      const error = `membership:${flow}:error-${statusDescription || 'system error'}`;
      sendTag(UtagType.view, page, { error });
    }

    setIsTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <AppHeader sx={{ padding: 0 }} />
      {flowType === FlowType.MAJOR_ROCKET ? (
        <div>
          {statusDescription ? (
            <>
              <Typography variant="b2Medium" className="mr-helper-text">
                We're sorry, there was an issue redeeming your coupon for the following reason: {statusDescription}
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="b2Medium" className="mr-helper-text">
                We're sorry, there was an issue redeeming your coupon.
              </Typography>
            </>
          )}
          <br />

          <div className="mr-contact-info">
            <Typography variant="b2Medium">
              Please contact us at{' '}
              <Link variant="b2Medium" href="mailto:support@aaamembershipoffers.com" target="_blank">
                Support@aaamembershipoffers.com
              </Link>{' '}
              to resolve.
            </Typography>
          </div>

          <br />
        </div>
      ) : (
        <div>
          <Box className="help-text" sx={{ background: '#EBEBED', padding: '0.5rem', borderRadius: '0.5rem' }}>
            <Typography variant="b3Regular" sx={{ color: '#404040' }}>
              We’re experiencing technical difficulties.
            </Typography>
            <Typography variant="b3Regular" sx={{ color: '#404040' }}>
              Please try again later, or have one of our agents assist you.
            </Typography>
          </Box>
          <Box
            className="contact-us-text"
            sx={{ background: '#EBEBED', padding: '0.5rem', borderRadius: '0.5rem', marginTop: '0.5rem' }}
          >
            <Typography variant="b3Regular" sx={{ color: '#404040' }}>
              You can reach us at {phoneNumber} or visit a AAA branch.
            </Typography>
          </Box>
          <ButtonGroup
            variant={{ sm: 'shared', md: 'shared', lg: 'shared', xl: 'shared' }}
            sx={{ marginTop: '0.5rem' }}
          >
            <Button
              className="call-club-number"
              label={`Call ${phoneNumber}`}
              variant="outlined"
              sx={{
                height: '34px',
                fontSize: '0.875rem',
                color: '#1C4DA6',
                borderColor: '#1C4DA6',
                lineHeight: '1rem',
              }}
              onClick={() => {
                window.open(`tel:${phoneNumber}`);
              }}
            ></Button>
            <Button
              className="see-nearest-branches"
              label="See nearest branches"
              variant="outlined"
              sx={{
                height: '34px',
                fontSize: '0.875rem',
                color: '#1C4DA6',
                borderColor: '#1C4DA6',
                lineHeight: '1rem',
              }}
              onClick={() => {
                window.open('https://www.aaa.com/office/', '_blank');
              }}
            ></Button>
          </ButtonGroup>
        </div>
      )}
      {offerToken && flowType === FlowType.MAJOR_ROCKET ? (
        <div>
          <Typography variant="b2Medium">Please save the following for your records:</Typography>
          <Typography variant="b2Medium">
            Coupon code: <strong>{offerToken}</strong>
          </Typography>
          <br />
          <Typography variant="b2Medium">
            Each code is unique, can only be redeemed once, and is valid for 1 year from the date issued.
          </Typography>
        </div>
      ) : (
        <div />
      )}
    </>
  );
};
